import { ClockClockwiseIcon, XCircleIcon } from '@phosphor-icons/react';

import { useTranslation } from '../../../contexts/translation-context';

interface Props {
  hasRejectedCmrs: boolean;
  hasPendingCmrs: boolean;
}

/** Carrier-facing status when a CMR is still being processed or was auto-rejected. */
export const CarrierPortalCmrStatus: React.FC<Props> = ({ hasRejectedCmrs, hasPendingCmrs }) => {
  const { i18n } = useTranslation();

  if (hasRejectedCmrs) {
    return (
      <div className="flex items-center gap-2 text-negative-text px-4">
        <XCircleIcon className="w-4 h-4" weight="bold" />
        {i18n('carrierPortal.orders.cmrRejected')}
      </div>
    );
  }

  if (hasPendingCmrs) {
    return (
      <div className="flex items-center gap-2 text-brand-text px-4">
        <ClockClockwiseIcon className="w-4 h-4" weight="bold" />
        {i18n('carrierPortal.orders.cmrPending')}
      </div>
    );
  }

  return null;
};
